export default __webpack_public_path__ + "static/media/speech_bubble.3c97f91d.png";